 /**
  * Project - fasthelp5.fa2chat-product
  *
  * @desc チャット開始画面
  *
  * @author genka
  * @copyright Copyright 2018 TechMatrix Corporation, Inc. All rights reserved.
  */
<template>
<el-container class="fc-chat-starter">
  <el-main style="display: flex; align-items: center; padding:0;">
    <el-button type="primary" class="chat-start-button" :disabled="!permissionChatStart" @click="doChatStart">
      <table class="chat-start-button-table" style="width:100%;">
        <tr>
          <td style="width:0">
            <div class="icoChatStart"></div>
          </td>
          <td class="chat-start-button-label-wrapper" style="width:auto%;">
            <div class="chat-start-button-label">{{chatJoinButtonLabel}}</div>
          </td>
        </tr>
      </table>
    </el-button>
  </el-main>
</el-container>
</template>

<script>
import {
  Container,
  Main,
  Button
} from 'element-ui'
import WindowUtil from '@/utils/WindowUtil'

export default {
  name: 'FcChatStarter',
  components: {
    'el-container': Container,
    'el-main': Main,
    'el-button': Button
  },
  data() {
    return {
      /**
       * FastChatサービス状態取得サービスをリクエスト中か
       * @type {Boolean}
       */
      requestingFindFastchatServiceStatus: false,

      /**
       * ボタンモード（''・・・チャットで質問する、'resume'・・・チャット再開する）
       * @type {String}
       */
      buttonMode: ''
    }
  },
  computed: {
    /**
     * 「チャットで質問する」の実行が可能か
     * @return {Boolean}
     */
    permissionChatStart() {
      return !this.requestingFindFastchatServiceStatus
    },
    /**
     * ボタンのラベル名
     * @return {[type]} [description]
     */
    chatJoinButtonLabel() {
      if (this.buttonMode === '') {
        return this.$t('チャットで質問する')
      } else if (this.buttonMode === 'resume') {
        return this.$t('チャットを再開する')
      }
    }
  },
  methods: {
    /**
     * 「チャットで質問する」表示に切り替える
     */
    changeButtonToChatStart() {
      this.buttonMode = ''
    },
    /**
     * 「チャットを再開する」表示に切り替える
     */
    changeButtonToChatResume() {
      this.buttonMode = 'resume'
    },
    /**
     * 「チャットで質問する」処理
     */
    doChatStart() {
      if (WindowUtil.isMobileScreenMode() || this.$config['_alwaysSeparateChatWindow']) {
        WindowUtil.postOpenSeparateChatWindowMessageToParent()
      } else {
        if (this.buttonMode === '') {
          if (this.permissionChatStart) {
            this.$emit('chatStart')
          }
        } else if (this.buttonMode === 'resume') {
          this.$emit('chatResume')
        }
      }
    }
  }
}
</script>

<style>
.fc-chat-starter {
  height: 100%;
}

.chat-start-button {
  width: 100%;
  height: 100%;
}

.chat-start-button-label {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/chatStarter/FcChatStarter.vue